import * as yup from 'yup';

export const checkboxInitialValues = {
    label: 'Label',
    name: 'check-box',
};

export const checkboxForm = [
    {
        id: '1',
        label: 'label',
        name: 'label',
        type: 'text',
        component: 'FormikTextField',
    },
    {
        id: '2',
        label: 'name',
        name: 'name',
        type: 'text',
        component: 'FormikTextField',
    },
];

export const checkboxValidation = {
    label: yup
        .string()
        .matches(/^[a-zA-Z0-9 ]*$/, 'Alphanumeric characters only')
        .required(),
    name: yup
        .string()
        .matches(
            /^([A-z0-9_-])*[^\s]\1*$/,
            'No spaces, only alphanumeric characters and hyphens are allowed'
        )
        .required(),
};
